import {Link, makeStyles, StarIcon} from '@logistics-frontend/blocks'
import React from 'react'

import {useStyles} from './styles'

type Props = {
  'data-e2e'?: string
  selected: boolean
  onClick: VoidFunction
}

const useStarStyles = makeStyles({
  root: {
    width: 40,
    height: 40,
  },
})

const Star: React.FC<Props> = ({selected, onClick, 'data-e2e': dataE2e}) => {
  const starClasses = useStarStyles()
  const classes = useStyles()
  return (
    <Link className={classes.star} onClick={onClick}>
      <StarIcon
        classes={starClasses}
        data-e2e={dataE2e}
        htmlColor={selected ? '#FCE000' : '#F1F0ED'}
        viewBox="0 0 40 40"
      />
    </Link>
  )
}

export default Star
